module.exports = __webpack_public_path__ + "static/media/product_not_found.19c36c00.svg";